import { UploadType } from '../../../../consts/uploadType';

export const uploadTypeToHuman = (type: UploadType) => {
  switch (type) {
    case UploadType.RegularAndRtk:
      return 'Regular & RTK';
    case UploadType.Ppk:
      return 'PPK';
    case UploadType.Lidar:
      return 'LiDAR';
    case UploadType.Pano:
      return 'Pano';
  }
};
